import * as actionTypes from './actionTypes'
import { Record, Map } from 'immutable'
import { ON_USER_FETCH_SUCCESS, ON_USER_FETCH_ERROR } from 'data/auth/actions'
// Undefined is absence of evidence. Null is evidence of absence.

const UpdateState = Record({
  ongoing: false,
  success: false,
  error: null,
})

const State = Record(
  {
    map: Map(),
    viewer: null,
    viewerError: null,
    updateAttributes: new UpdateState(),
    updateEmail: new UpdateState(),
    updatePhoto: new UpdateState(),
    updateOrganizationRole: Map(),
  },
  'users'
)

const UsersReducer = (state = new State(), { type, payload, meta }) => {
  switch (type) {
    case ON_USER_FETCH_SUCCESS: {
      const { user } = payload
      return state
        .update('map', map => map.set(user.id, user))
        .set('viewer', user)
        .set('viewerError', null)
    }
    case ON_USER_FETCH_ERROR: {
      return state.set('viewer', null).set('viewerError', payload)
    }

    case actionTypes.UPDATE_USER_START: {
      return state.set('updateAttributes', new UpdateState({ ongoing: true }))
    }

    case actionTypes.UPDATE_USER_SUCCESS: {
      return state.set('updateAttributes', new UpdateState({ success: true }))
    }

    case actionTypes.UPDATE_USER_ERROR: {
      return state.set('updateAttributes', new UpdateState({ error: payload }))
    }

    case actionTypes.UPDATE_USER_PHOTO_START: {
      return state.set('updatePhoto', new UpdateState({ ongoing: true }))
    }

    case actionTypes.UPDATE_USER_PHOTO_SUCCESS: {
      return state.set('updatePhoto', new UpdateState({ success: true }))
    }

    case actionTypes.UPDATE_USER_PHOTO_ERROR: {
      return state.set('updatePhoto', new UpdateState({ error: payload }))
    }

    case actionTypes.UPDATE_USER_EMAIL_START: {
      return state.set('updateEmail', new UpdateState({ ongoing: true }))
    }

    case actionTypes.UPDATE_USER_EMAIL_SUCCESS: {
      return state.set('updateEmail', new UpdateState({ success: true }))
    }

    case actionTypes.UPDATE_USER_EMAIL_ERROR: {
      return state.set('updateEmail', new UpdateState({ error: payload }))
    }

    case actionTypes.UPDATE_USER_ORGANIZATION_ROLE_START: {
      const { userId } = meta.action.meta
      return state.setIn(
        ['updateOrganizationRole', userId],
        new UpdateState({ ongoing: true })
      )
    }

    case actionTypes.UPDATE_USER_ORGANIZATION_ROLE_SUCCESS: {
      const { userId } = meta.action.meta
      return state.updateIn(['updateOrganizationRole', userId], record =>
        record.merge({ ongoing: false, success: true })
      )
    }
    case actionTypes.UPDATE_USER_ORGANIZATION_ROLE_ERROR: {
      const error = payload
      const { userId } = meta.action.meta
      return state.updateIn(['updateOrganizationRole', userId], record =>
        record.merge({ ongoing: false, error })
      )
    }
    default:
      return state
  }
}

export default UsersReducer
